<template>
    <div>
        <main class="main-content mt-0">
            <section>
                <div class="page-header min-vh-100">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0 mx-auto">
                                <div class="card card-plain">
                                    <div class="card-header pb-0 text-start" style="background-color: transparent;">
                                        <img src="@/assets/images/logo_duarte_mod.png" alt="Duarte" class="img-fluid">
                                    </div>
                                    <div class="card-body">
                                        <form role="form">
                                            <div class="mb-3">
                                                <input @keyup.enter="keyEnter(0)" v-model="Usuario.username" type="text" placeholder="Nombre del usuario" class="form-control form-control-lg" ref="user">
                                            </div>

                                            <div class="input-icons mb-3">
                                                <input @keyup.enter="keyEnter(1)" v-model="Usuario.password" :type="type" class="form-control form-control-lg" placeholder="Contraseña" aria-label="Password" ref="pass">
                                                <button v-if="Usuario.password !== ''" @click="ToggleShow" class="button btn-password" type="button" id="button-addon2">
                                                    <i class="far icono-password" :class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"></i>
                                                </button>
                                            </div>

                                            
                                            <div class="text-center">
                                                <button :disabled="disabled" @click="GetLogin" type="button" class="btn btn-lg btn-primary btn-lg w-100 mt-4 mb-0">
                                                    <i v-if="disabled" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                                                    Iniciar sesión
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="card-footer text-center pt-0 px-lg-2 px-1">
                                        <p class="mb-4 text-sm mx-auto">
                                            ¿No tiene cuenta?
                                            <a href="javascript:;" class="text-primary text-gradient font-weight-bold">Regístrate</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 d-lg-flex d-none h-100 my-auto pe-0 position-absolute top-0 end-0 text-center justify-content-center flex-column">
                                <div class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden" :style=" cssProps">
                                    <span class="mask bg-gradient-primary opacity-6"></span>
                                    <ul class="circles">
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<script>

    export default {
        name:       'Login',
        props:      [""],
        components: {},
        data() {
            return {                
                type:            'password',
                showPassword:    false,
                password:        null,
                disabled:        false,
                errorvalidacion: [],
                Usuario: {
                    username: '',
                    password: '',
                },
                cssProps: {
                    backgroundImage: `url(${require('@/assets/style/image/item_login_01.jpg')})`,
                    backgroundSize: 'cover'
                    
                },
                Icono: 'eye cursor-pointer',
            }
        },
        methods: {
            async GetLogin() {

                if (this.Usuario.username !== '' && this.Usuario.password !== '') {

                    this.disabled = true;

                    this.$http.post('login', this.Usuario).then((res) =>  {

                        this.disabled = false;

                        if (res.data.status) {
                            this.$store.dispatch('login',      res.data);
                            sessionStorage.setItem('RutaFile', res.data.RutaFile);
                            this.$router.push({name: "inicio", params: {}});
                        } else {
                            this.$toast.warning('Usuario o Contraseña Incorrectos');
                        }

                    })
                    .catch((err) => {
                        this.disabled = false;
                        this.$toast.error(err.response.data.message, 'Error');
                        this.$store.commit('auth_error');
                        this.$store.localStorage.removeItem('user_token');
                        this.$store.reject(err);
                    });
                } else {
                    this.$toast.error('Ingrese los campos faltantes', 'Campos Incompletos,');
                }

            },
            keyEnter(num) {

                if (this.Usuario.username !== '' && this.Usuario.password !== '') {
                    this.GetLogin();
                } else if (num === 0  && this.Usuario.password === ''){
                    this.$refs.pass.focus();
                } else if (num === 1 && this.Usuario.username === ''){
                    this.$refs.user.focus();
                }
            },
            ToggleShow() {

                if (this.showPassword = !this.showPassword) {                    
                    this.type = 'text';
                    this.Icono = 'eyeClose cursor-pointer';
                } else {
                    this.type = 'password';
                    this.Icono = 'eye cursor-pointer';
                }
                
            },
        },
        created() {
            // SI EXISTE SESSIÓN REGRESAMOS A LA VISTA PRINCIPAL (INICIO)
            var datos = JSON.parse( sessionStorage.getItem('user'));

            if(datos != null){
                this.$router.push({name: "inicio", params: {}});
            }

        },
        mounted() {
            this.$refs.user.focus();
        },
    }

</script>
<style>
    /*--- Animacion ---*/
    .circles{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    }

    .circles li{
    position: absolute;
    display: block;
    list-style: none;
    width: 20px;
    height: 20px;
    background: rgba(255, 255, 255, 0.2);
    animation: animate 25s linear infinite;
    bottom: -150px;
    
    }

    .circles li:nth-child(1){
    left: 25%;
    width: 80px;
    height: 80px;
    animation-delay: 0s;
    }


    .circles li:nth-child(2){
    left: 10%;
    width: 20px;
    height: 20px;
    animation-delay: 2s;
    animation-duration: 12s;
    }

    .circles li:nth-child(3){
    left: 70%;
    width: 20px;
    height: 20px;
    animation-delay: 4s;
    }

    .circles li:nth-child(4){
    left: 40%;
    width: 60px;
    height: 60px;
    animation-delay: 0s;
    animation-duration: 18s;
    }

    .circles li:nth-child(5){
    left: 65%;
    width: 20px;
    height: 20px;
    animation-delay: 0s;
    }

    .circles li:nth-child(6){
    left: 75%;
    width: 110px;
    height: 110px;
    animation-delay: 3s;
    }

    .circles li:nth-child(7){
    left: 35%;
    width: 150px;
    height: 150px;
    animation-delay: 7s;
    }

    .circles li:nth-child(8){
    left: 50%;
    width: 25px;
    height: 25px;
    animation-delay: 15s;
    animation-duration: 45s;
    }

    .circles li:nth-child(9){
    left: 20%;
    width: 15px;
    height: 15px;
    animation-delay: 2s;
    animation-duration: 35s;
    }

    .circles li:nth-child(10)
    {
    left: 85%;
    width: 150px;
    height: 150px;
    animation-delay: 0s;
    animation-duration: 11s;
    }

    .pr-1{
    padding-right: 1rem;
    }


    @keyframes animate {

    0%{
        transform: translateY(0) rotate(0deg);
        opacity: 1;
        border-radius: 0;
    }

    100%{
        transform: translateY(-1000px) rotate(720deg);
        opacity: 0;
        border-radius: 50%;
    }

    }

    .bg-03
    {
    background-color: whitesmoke;
    }
</style>
